<template>
  <div>
    <b-card
      :img-src="squareImage"
      img-left
      tag="article"
      :class="[{active: isSelected}, {'sidebar-disabled': !mapIsLoaded}]"
      role="button"
      @click.stop="walkSelected(id)"
    >
      <b-card-text>{{ text }}</b-card-text>
      <div v-if="hasDetails">
        <b-button variant="info" class="float-right btn-circle" @click.stop="showModal(id)">
          <font-awesome-icon :icon="['fas', 'info']" />
        </b-button>
      </div>
    </b-card>

    <b-modal :ref="id" :title="text">
      <b-img v-if="hasDetails" :src="modalImage" fluid :alt="description"></b-img>
      <p class="pt-2">{{ description }}</p>
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">
          <font-awesome-icon class="mr-2" :icon="['fas', 'times']" />Close
        </b-button>
        <b-button variant="info" @click.stop="walkSelected(id, true)">
          <font-awesome-icon class="mr-2" :icon="['fas', 'search-plus']" />Zoom to
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    images: null,
    text: null,
    id: null,
    description: null,
    selectedCardId: null,
    mapIsLoaded: null,
  },

  data() {
    return {
      selectedTrack: false,
    };
  },

  computed: {
    isSelected() {
      return this.id === this.selectedCardId;
    },

    squareImage() {
      if (this.images) {
        return this.images.SquareImage;
      }
      return "logo.png";
    },

    modalImage() {
      if (this.images) {
        return this.images.LandscapeImage;
      }
      return "";
    },
    hasDetails() {
      if (this.images && this.text && this.id && this.description) {
        return true;
      }
      return false;
    },
  },

  methods: {
    walkSelected: function (id, zoomButtonClicked) {
      if (!this.mapIsLoaded) {
        return;
      }
      this.selectedTrack = !this.selectedTrack;
      if (zoomButtonClicked) {
        this.selectedTrack = true;
      }
      this.$emit("walkSelected", id, this.selectedTrack, this.isSelected);
      this.$refs[id].hide();
    },
    showModal: function (id) {
      if (!this.mapIsLoaded) {
        return;
      }
      this.$refs[id].show();
    },
  },
};
</script>

<style scoped>

.active {
  background: #456b8d !important;
}

.card {
  background: #343a40;
}

.card:hover:not(.sidebar-disabled) {
  background: #44617d;
}

.card img {
  width: 15%;
  padding-top: 5px;
  padding-bottom: 5px;
}

.card-text {
  margin-bottom: 0;
}

.btn-circle {
  border-radius: 50% !important;
  height: 30px;
  vertical-align: middle;
  text-align: center;
  line-height: 1;
  transform: translate(-50%,-75%);
  position: absolute;
  right: 20px;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  p {
    font-size: 12px;
  }
}
</style>
